import { IDepositLimitsSettings } from 'js/hooks/socket/hooks/useGetCasinoDepositLimitsSettings/types';
import { IBetLimitConfigurationItem, ILossLimitConfigurationItem } from 'js/hooks/socket/hooks/useGetRGConfiguration/types';

import * as Types from './types';
import { actionTypes } from './constants';

export const setFormData = (data: Types.FormData): Types.ISetFormDataAction => ({
    type: actionTypes.SET_FORM_DATA,
    payload: data
});

export const toggleLoading = (isLoading: boolean): Types.IToggleIsLoadingAction => ({
    type: actionTypes.TOGGLE_LOADING,
    payload: isLoading
});

export const setHiddenByRulesFields = (filedNames: string[]): Types.ISetHiddenByRulesFieldsAction => ({
    type: actionTypes.SET_HIDDEN_BY_RULES_FIELDS,
    payload: filedNames
});

export const addHiddenField = (filedName: string): Types.IAddHiddenFieldAction => ({
    type: actionTypes.ADD_HIDDEN_FIELD,
    payload: filedName
});

export const removeHiddenField = (filedName: string): Types.IRemoveHiddenFieldAction => ({
    type: actionTypes.REMOVE_HIDDEN_FIELD,
    payload: filedName
});

export const setFormInternalError = (error: string): Types.ISetFormInternalErrorAction => ({
    type: actionTypes.SET_FORM_INTERNAL_ERROR,
    payload: error
});

export const setLimitsCurrency = (currency: string): Types.ISetLimitsCurrencyAction => ({
    type: actionTypes.SET_LIMITS_CURRENCY,
    payload: currency
});

export const updateImsValues = (imsValues: Record<string, any>): Types.IUpdateImsValuesAction => ({
    type: actionTypes.UPDATE_IMS_VALUES,
    payload: imsValues
});

export const setLimitsSettings = (
    type: 'bet' | 'loss' | 'deposit',
    settings: IDepositLimitsSettings | IBetLimitConfigurationItem | ILossLimitConfigurationItem
): Types.ISetLimitsSettingsAction => ({
    type: actionTypes.SET_LIMITS_SETTINGS,
    payload: { type, settings }
});
